const module = { name: 'layouts/base.app', exports: {} }; const exports = module.exports;



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { shared_global_covidAnnouncementModal as covidAnnouncementModal } from 'require-global';



import { shared_global_globalOfferBanner as globalOfferBanner } from 'require-global';



import { Fandango_debugLog as debugLog } from 'require-core';



import { Fandango_geolocator as geolocator } from 'require-global';



import { shared_global_immediateAdLoad as immediateAdLoad } from 'require-global';



import { fd_url_manager as links } from 'require-core';

function run() {
    checkDependencies(module.name, debugLog);
    geolocator.init({
        searchUrl: links.napiLocationSearch(),
        reverseUrl: links.napiLocationReverse(),
    });
    const changeLog = [
        'TAKE2-4723',
        'TAKE2-4725',
        'TAKE2-4769',
    ];
    debugLog.info('changeLog', changeLog);
    immediateAdLoad.init();
    covidAnnouncementModal.init();
    globalOfferBanner.initTracking();
}
run();
export default module.exports;